import { render } from "./AddEditPackageModal.vue?vue&type=template&id=1204817e&scoped=true"
import script from "./AddEditPackageModal.vue?vue&type=script&lang=js"
export * from "./AddEditPackageModal.vue?vue&type=script&lang=js"

import "./AddEditPackageModal.vue?vue&type=style&index=0&id=1204817e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1204817e"]])

export default __exports__